"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginDefinition_1 = require("../PluginDefinition");
/**
 * Widget step plugin definition.
 */
class WidgetStepPluginDefinition extends PluginDefinition_1.default {
    /**
     * @inheritDoc
     */
    constructor(definition) {
        super(definition);
        /**
         * Whether the step is linear.
         */
        this.linear = true;
        if (definition.linear !== undefined) {
            this.linear = definition.linear;
        }
    }
    /**
     * @inheritDoc
     */
    static getType() {
        return "widget_step";
    }
    /**
     * Determines whether the step is linear and should be indexed.
     *
     * Non linear steps are not connected in line to other steps and can
     * only be reached by specific application.
     *
     * @return {boolean}
     */
    isLinear() {
        return this.linear;
    }
}
exports.default = WidgetStepPluginDefinition;
